import { render, staticRenderFns } from "./SnapshotImportAssets.vue?vue&type=template&id=5b48b73c&scoped=true&"
import script from "./SnapshotImportAssets.vue?vue&type=script&lang=ts&"
export * from "./SnapshotImportAssets.vue?vue&type=script&lang=ts&"
import style0 from "./SnapshotImportAssets.vue?vue&type=style&index=0&id=5b48b73c&scoped=true&lang=scss&"
import style1 from "./SnapshotImportAssets.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b48b73c",
  null
  
)

export default component.exports